
<template>
  <div>
    <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable max-width="500px" >
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template> -->
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark class="blue-grey darken-1 white--text" >
            <v-toolbar-title>Cancelando boleto</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="$emit('closeDialog')" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-row class="pa-2">
            <v-alert type="error" :value="true" class="my-5">
              <h4>Esse boleto será cancelado, mas a dívida ainda estará em aberto</h4>
            </v-alert>
          </v-row>
          <v-row class="justify-center">
            <b class="title">Realmente cancelar o boleto?</b>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-space-around">
          <f-btn cancel alt_text="não" @click="$emit('closeDialog')">não</f-btn>
          <f-btn save alt_text="sim" alt_icon="mdi-check" @click="cancelBill()"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import status from "@/_backoffice/_financial/mixins/status.js"

export default {
  name: 'DialogCancelBill',
  mixins: [status],
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    bill: {
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      edited_bill: {}
    }
  },
  mounted () {
    this.setBill();
  },
  methods: {
    setBill() {
      this.edited_bill = {type: this.bill.type, ...this.bill.attributes};
    },
    editBill() {
      this.loading = true;

      this.updateBill(this.edited_bill);
    },
    cancelBill() {
      let now = new Date().toISOString();
      this.edited_bill.canceled = true;
      this.edited_bill.canceled_at = now.substring(0,10) + ' ' + now.substring(11,19);
      this.edited_bill.canceled_by_id = this.one_user.id;
      this.edited_bill.canceled_due = 'Boleto cancelado';

      this.edited_bill.concluded_at = now.substring(0,10) + ' ' + now.substring(11,19);
      this.edited_bill.status_id = this.concluded_id;

      this.editBill();
      this.$emit('closeDialog');
    },
    ...mapActions({
      updateBill: 'Bill/update',
    })
  },
  computed: {
    concluded_id() {
      return this.status_id_map["Concluded"]
    },
    ...mapState({
      one_user: state => state.User.oneUser,
      all_statuses: state => state.Status.all_statuses
    })
  },
}
</script>